import { Builder, withChildren } from '@builder.io/react';

import { Section } from 'react-scale/components';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'SectionSlideGallery',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean'
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'SectionTitle',
        options: {
          overtitle: 'Duis Mollis',
          title: 'Sed posuere consectetur estat lobortis posuere',
          subtitle:
            'Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio.'
        }
      }
    },
    {
      component: {
        name: 'SlideGallery',
        options: {}
      }
    }
  ]
});
